export default __webpack_public_path__ + "static/media/sorting.15188e10.png";